import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import SearchBox from 'components/site/SearchBox';
import CustomerSearchStore from 'stores/CustomerSearchStore';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import { debounce } from 'lodash';
import { titleize } from 'underscore.string';
import { renderItem } from './CustomerSearchItem';
function getCustomerValue(item) {
    return titleize(item.optimized_name);
}
function getCustomerName(item) {
    switch (item.type) {
        case 'Carrier':
            return item.name;
        case 'Shipper':
        case 'Vendor':
            return item.company_name;
        default:
            return `${item.first_name} ${item.last_name}`;
    }
}
class CustomerSearch extends Component {
    constructor(props) {
        super(props);
        this.handleCustomerStoreChange = () => {
            const customers = CustomerSearchStore.getSearchResults();
            customers.sort((a, b) => {
                // Most shippers have undefined
                if ((a.authorized === true || a.authorized === undefined) &&
                    b.authorized === false) {
                    return -1;
                }
                if (a.authorized === false &&
                    (b.authorized === true || b.authorized === undefined)) {
                    return 1;
                }
                return getCustomerName(a).localeCompare(getCustomerName(b));
            });
            this.setState({ customers });
        };
        this.handleChange = (nGram) => {
            if (!nGram || nGram.length <= 2) {
                CustomerSearchStore.clearSearchResults();
            }
            if (this.props.onChange) {
                this.props.onChange(nGram);
            }
        };
        this.handleUserSelect = (value, item) => {
            const unauthorized = this.isCarrierOrDriver(item) && !item.authorized;
            if (unauthorized && !this.props.allowUnauthorizedCarriers) {
                return;
            }
            CustomerSearchStore.clearSearchResults();
            this.props.onSelect(value, item);
        };
        this.state = {
            customers: [],
        };
        this.handleSearch = debounce(this.handleSearch, 300);
    }
    componentDidMount() {
        CustomerSearchStore.addChangeListener(this.handleCustomerStoreChange);
    }
    componentWillUnmount() {
        CustomerSearchStore.removeChangeListener(this.handleCustomerStoreChange);
        CustomerSearchStore.clearSearchResults();
    }
    clear() {
        this.setState({ customers: [] });
    }
    handleSearch(nGram) {
        const { type: customerType, authorizedOnly } = this.props;
        const params = {
            name: nGram,
        };
        if (customerType) {
            params.customerType = customerType;
        }
        params.authorizedOnly = authorizedOnly;
        CustomersActionCreators.searchCustomers(params);
    }
    isCarrierOrDriver(item) {
        return item.type === 'Driver' || item.type === 'Carrier';
    }
    render() {
        return (React.createElement(SearchBox, { id: this.props.id, items: this.state.customers, clear: () => this.clear(), disabled: this.props.disabled, search: (nGram) => this.handleSearch(nGram), placeholder: this.props.placeholder, defaultValue: this.props.defaultValue, menuStyle: this.props.menuStyle, value: this.props.value, onChange: (value) => this.handleChange(value), onSelect: this.handleUserSelect, getItemValue: this.props.displayValue || getCustomerValue, renderItem: renderItem, inputStyle: this.props.inputStyle }));
    }
}
CustomerSearch.propTypes = {
    onSelect: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    type: PropTypes.string,
    defaultValue: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    authorizedOnly: PropTypes.bool,
    allowUnauthorizedCarriers: PropTypes.bool,
};
CustomerSearch.defaultProps = {
    defaultValue: '',
    disabled: false,
    placeholder: 'Search for customers..',
    type: '',
    value: '',
    authorizedOnly: false,
    allowUnauthorizedCarriers: false,
};
export default withRouter(CustomerSearch);
